<template>
    <div v-if="statusText" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold" :class="badgeClass">
        {{ statusText }}
    </div>
</template>

<script>
export default {
    props: {
        // Boleh kosong: pemanggil kerap merender badge sebelum data booking selesai dimuat
        // (mis. PaymentSummaryModal). Status kosong = badge tidak dirender sama sekali,
        // bukan chip "Unknown" — itu asal-usul badge Unknown yang selama ini muncul.
        // String juga diterima: status transaksi pembayaran datang sebagai "PAID"/"UNPAID"/
        // "EXPIRED" (bukan enum numerik Books.Status) dan dipetakan lewat statusMap sendiri.
        status: {
            type: [Number, String],
            default: null,
        },
        statusMap: {
            type: Object,
            default: () => ({
                1: { text: "Cart", color: "bg-gray-100 text-gray-700" },
                2: { text: "Unpaid", color: "bg-yellow-100 text-yellow-700" },
                3: { text: "Expired", color: "bg-red-100 text-red-700" },
                4: { text: "Paid", color: "bg-green-100 text-green-700" },
                5: { text: "Canceled", color: "bg-gray-100 text-gray-700" },
                6: { text: "Generated", color: "bg-gray-100 text-gray-700" },
                7: { text: "Confirmed", color: "bg-green-100 text-green-700" },
                8: { text: "Ready To Pay", color: "bg-gray-100 text-gray-700" },
                9: { text: "Completed", color: "bg-green-100 text-green-700" },
                10: { text: "Confirmed", color: "bg-green-100 text-green-700" },
                11: { text: "Canceled", color: "bg-gray-100 text-gray-700" },

            }),
        },
    },
    computed: {
        badgeClass() {
            return this.statusMap[this.status]?.color || "bg-gray-100 text-gray-700";
        },
        statusText() {
            if (this.status === null || this.status === undefined || this.status === "") return "";
            // Kode baru yang belum dipetakan tetap kelihatan (bukan disembunyikan) supaya
            // ketahuan harus ditambah ke statusMap — "Unknown" tidak memberi petunjuk apa pun.
            return this.statusMap[this.status]?.text || `Status ${this.status}`;
        },
    },
};
</script>

<style scoped>
/* Tambahkan styling tambahan jika dibutuhkan */
</style>